import { Pipe, PipeTransform } from '@angular/core';

import {
  POLICY_RENEWAL_STATUS,
  PolicyRenewalStatus,
} from '@lockton-apps/shared/interfaces';

@Pipe({
  name: 'policyStatusDescription',
  standalone: true,
})
export class PolicyStatusDescriptionPipe implements PipeTransform {
  metaMap = new Map<PolicyRenewalStatus, string>([
    [POLICY_RENEWAL_STATUS.Active, 'Active'],
    [POLICY_RENEWAL_STATUS.Expired, 'Expired'],
    [POLICY_RENEWAL_STATUS.RenewalImminent, 'Expiring'],
    [POLICY_RENEWAL_STATUS.RenewalUpcoming, 'Upcoming Expiry'],
  ]);

  transform(value: PolicyRenewalStatus): string {
    return this.metaMap.get(value) || 'unknown';
  }
}
